<ng-container
  *ngLet="{
    data: data | async,
    pageCount: pageCount | async,
    trackBy: trackBy | async,
    view: view | async,
    columnsSelected: columnsSelected,
    isLoading: isLoading | async
  } as vm"
>
  <div
    class="container"
    [class.no-top-radius]="flatTop"
    [class.rv-scrollable]="scrollable"
    [class.no-shadow]="noShadow"
    [class.no-border]="noBorder"
    [style.max-height]="maxHeight"
    #scroller
    (scroll)="onScroll($event)"
  >
    <table
      class="rv-plain-table super-table"
      [class.fit]="!superTableStickyCells.length"
    >
      <thead class="sticky-header">
        <ng-content select="[superTableHeaderRow]"></ng-content>
      </thead>
      <tbody *ngIf="!isLoading ? vm.data : olddata as result; else initialLoad">
        <ng-container
          *ngIf="
            parentEnabledColumns
              ? parentEnabledColumns.length
              : vm.columnsSelected
          "
        >
          <ng-container *ngFor="let row of result.data; trackBy: vm.trackBy">
            <ng-container
              *ngTemplateOutlet="
                rowDirective.template;
                context: { $implicit: row }
              "
            ></ng-container>
          </ng-container>
        </ng-container>
        <tr
          *ngIf="
            !result.data?.length ||
            (parentEnabledColumns
              ? !parentEnabledColumns.length
              : !vm.columnsSelected)
          "
        >
          <td
            superTableCellAlternate
            [colSpan]="superTableHeaderComponents.length"
            *ngIf="emptyAlternate"
          >
            <ng-container *ngTemplateOutlet="empty"></ng-container>
          </td>
          <td
            superTableCell
            [colSpan]="superTableHeaderComponents.length"
            *ngIf="!emptyAlternate"
            class="empty-cell"
          >
            <ng-container *ngTemplateOutlet="empty"></ng-container>
          </td>
          <ng-template #empty>
            <ng-container [ngSwitch]="true">
              <ng-container *ngSwitchCase="result.noFilterSearch?.empty">
                {{ emptyText }}
                <ng-content select="[emptyContent]"></ng-content>
              </ng-container>
              <ng-container
                *ngSwitchCase="
                  !result.noFilterSearch?.empty && result.noSearch?.empty
                "
              >
                No records match your filters.
              </ng-container>
              <ng-container
                *ngSwitchCase="
                  result.data?.length &&
                  (parentEnabledColumns
                    ? !parentEnabledColumns.length
                    : !vm.columnsSelected)
                "
              >
                <ng-container *ngIf="columnsLoaded"
                  >All columns toggled off. Select some columns above to get
                  started!</ng-container
                >
                <ng-container *ngIf="!columnsLoaded"
                  >Column preferences loading...</ng-container
                >
              </ng-container>
              <ng-container *ngSwitchDefault>
                No records match your search.
              </ng-container>
            </ng-container>
          </ng-template>
        </tr>
      </tbody>
      <ng-template #initialLoad>
        <tbody>
          <tr>
            <td [colSpan]="superTableHeaderComponents.length"></td>
          </tr>
        </tbody>
      </ng-template>
    </table>
  </div>
  <div
    *ngIf="
      !groupStyling &&
      vm.view &&
      (vm.pageCount > 1 || (vm.data && vm.data.data.length > pageSizes[0]))
    "
    class="rv-flex"
  >
    <div class="results">
      Results per page:
      <select-dropdown
        [selectedOptionId]="vm.view.pageSize?.toString()"
        (selectedOptionIdChange)="
          changeView.next({ pageSize: +$event, page: 0 })
        "
        [options]="pageSizeOptions"
      ></select-dropdown>
      <span *ngIf="totalText" class="total-text">{{ totalText }}</span>
    </div>
    <pages
      [current]="vm.view.page"
      [count]="vm.pageCount"
      (currentChange)="changeView.next({ page: $event })"
    ></pages>
  </div>
  <div
    class="pagination-placeholder"
    *ngIf="
      !groupStyling &&
      vm.view &&
      vm.isLoading &&
      olddata &&
      olddata.noRange.count > pageSizes[0]
    "
  ></div>
  <ng-template #columnSelect>
    <table-column-select
      [options]="columnDropdownOptions"
      [tableName]="name"
      [pinned]="persistedColumns | async"
      [fromStorage]="persistedColumnsSelected | async"
      (selectedColumns)="selectedColumns.next($event)"
      (onDragEvent)="handleDragEvent($event, false)"
      (onPinnedEvent)="handlePinnedEvent($event)"
    ></table-column-select>
  </ng-template>
</ng-container>
